import React from 'react';
import TextField from '@material-ui/core/TextField';
import {useDispatch,useSelector} from 'react-redux'
import {isEmpty} from 'lodash'
import {getDistriktByAfid} from 'actions'
import IntlMessages from 'util/IntlMessages';

function SelectKunderDistrikt(props) {
    const dispatch = useDispatch()
    const AfDistrikt = useSelector(state => state.accountsData.AfDistrikt)
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    const userRole = useSelector(state => state.auth.authUser.user_role)
    const [Value,setValue] = React.useState(0)
    React.useEffect(() => {
        dispatch(getDistriktByAfid(Afid, userid))
    }, [])
    const setKundDistirikt=(e)=>{
        props.onChangeHandleMulti("Distrikt",e.target.value)  
    }
    return (
        <div>
            {
                parseInt(userRole) > 1?"":
                <form>
                    <div style={{ height: 'auto', paddingTop: '10px' }}>
                        <TextField
                            select
                            label={<IntlMessages id="Label.District" />}
                            variant="outlined"
                            size="small"
                            value={Value}
                            fullWidth
                            onChange={setKundDistirikt}
                            SelectProps={{
                                native: true,
                            }}
                            >
                                <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
                                <option Key="-1" value={-1}><IntlMessages id="All"/></option>
                                {
                                    isEmpty(AfDistrikt)?"":
                                    AfDistrikt.map((option,index) => (
                                        <option key={index} value={option.id}>
                                            {option.Name}
                                        </option>
                                ))}
                        </TextField>
                    </div>
                </form>
            }
        </div>
    );
}

export default SelectKunderDistrikt;